import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=07709653&scoped=true&"
import script from "./DataForm.vue?vue&type=script&lang=js&"
export * from "./DataForm.vue?vue&type=script&lang=js&"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=07709653&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07709653",
  null
  
)

export default component.exports